import { editor3DTours } from "../tours/editor3DTours";
import { shortcutGroups3D } from "../shortcuts/shortcutGroups";
import type { OnboardingStrategy } from "../onboardingTypes";

/**
 * 3D onboarding content — phase 2.
 *
 * Deliberately empty rather than absent: OnboardingHost resolves a strategy
 * for every training type, and an empty tour list is the honest way to say
 * "3D has no onboarding yet". The content is drafted in
 * docs/ONBOARDING_REDESIGN_PLAN.md §4, and lands together with its anchors —
 * the usage test rejects registry entries that are not yet applied.
 *
 * Note the 3D empty-project case is starker than 360: show3DEmptyHero
 * (TrainingEditor.tsx:82-85) replaces the entire editor body, so every one of
 * the drafted stage-B anchors is absent until the first take exists.
 */
export const OnboardingStrategy3D: OnboardingStrategy = {
  tours: editor3DTours,
  hints: [],
  shortcutGroups: shortcutGroups3D,
};
